/**
 * L'effacement d'une bulle de la carte : une seule raison de pâlir à la fois. Règle pure,
 * testée dans tests/client/carte/effacement.test.ts.
 *
 * Correctif du ticket 04 du chantier `priorites` (et point 3 du ticket 19 de
 * `retours-testeurs`) : une bulle cachée (l'étape qui la contient est fermée) attend sur sa
 * mère, à opacité 0. Le geste de hiérarchiser (`noeud--inerte`, 0,45) posait sa classe en
 * plus, et sa règle, écrite après dans `NoeudCarte.css`, lui rendait une opacité : les étapes
 * fermées se lisaient empilées sous leur mère. La cachée l'emporte, puis l'inerte.
 *
 * Le calque d'importance n'efface plus rien sur la Carte (chantier `revue-design`, ticket 04,
 * décision d'Igor du 2026-10-03, « La Carte » 2) : il est devenu une taille
 * (`filtreDeLaCarte.ts`), qu'une bulle cachée ne prend pas.
 */
export type Effacement = 'noeud--cachee' | 'noeud--inerte';

export function effacementDuNoeud({
  cachee,
  inerte,
}: {
  cachee: boolean;
  inerte: boolean;
}): Effacement | null {
  if (cachee) return 'noeud--cachee';
  if (inerte) return 'noeud--inerte';
  return null;
}
